module.exports = __webpack_public_path__ + "img/java.27b13335.svg";